import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook" })
], -1)
const _hoisted_2 = { class: "text-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "progress-bar bg-loupey-green",
      role: "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      style: {"width":"60%"}
    })
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-chevron-circle-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("tr", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args))),
    style: {"cursor":"pointer"}
  }, [
    _hoisted_1,
    _createElementVNode("td", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'template-detail', params: { id: this.id }},
        title: "Show details for this template"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.name), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.lastUsedDuration), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.totalMessagesFormatted), 1)
    ]),
    _hoisted_3,
    _createElementVNode("td", null, [
      _createVNode(_component_router_link, {
        to: { name: 'template-detail', params: { id: this.id }},
        title: "Show details for this template"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}